import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({ 
    title, 
    description, 
    keywords, 
    image, 
    url, 
    type = 'article',
    publishedTime,
    modifiedTime,
    author = 'Oleg Orlenko',
    siteName = 'Oleg Orlenko'
}) {
    const siteUrl = 'https://olegorlenko.com';
    const fullUrl = `${siteUrl}${url}`;
    const fullImageUrl = image ? `${siteUrl}${image}` : `${siteUrl}/images/L2w.png`;

    // Prepare structured data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": type,
        "headline": title,
        "description": description,
        "image": fullImageUrl,
        "url": fullUrl,
        "author": {
            "@type": "Person",
            "name": author
        },
        "publisher": {
            "@type": "Organization",
            "name": siteName,
            "logo": {
                "@type": "ImageObject",
                "url": `${siteUrl}/images/L2w.png`
            }
        }
    };

    if (publishedTime) {
        structuredData.datePublished = publishedTime;
    }
    if (modifiedTime) {
        structuredData.dateModified = modifiedTime;
    }

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={siteName} />

            {/* Twitter Card Meta Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImageUrl} />

            {/* Article Specific Meta Tags */}
            {publishedTime && <meta property="article:published_time" content={publishedTime} />}
            {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
            <meta property="article:author" content={author} />
            <meta property="article:section" content="Technology" />

            {/* Canonical URL */}
            <link rel="canonical" href={fullUrl} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
}

export default SEO; 